import React from "react"

const NameBox = ({ value, color, selectedPoint, setName, setColor, mapType }) => {

    return (
        <div className="nameBox">
            <input
                className="nameBox"
                type="text"
                style={{borderColor: color, borderWidth: "5px"}}
                value={value}
                onChange={event => {
                    if (mapType === "GuessNames") {
                        setName(event.target.value)}
                }
                }
                onKeyPress={event => {
                    if (event.charCode === 13) {
                        if (value === selectedPoint) {
                            setColor("green")
                        } else {
                            setName(selectedPoint)
                            setColor("red")
                        }
                    }
                }
                }
            />
        </div>
    )
}

export default NameBox
